import { Directive } from '@angular/core';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { Router } from '@angular/router';
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { RoutingPages } from 'src/app/enums/routing/routing-pages.enum';

@Directive({
  selector: '[redirectLogin]'
})
export class RedirectLoginDirective {

  constructor( 
    private _session: SessionManager,
    private _router : Router
  ) {
    this.checkIfLogged()
  }

  checkIfLogged () 
  {
    let user = this._session.user().get()

    if (isSessionCode(user)) {
      this._router.navigate ( [RoutingPages.LANDING_OLD] )
    }
  }
}
